import type { PdfTextItem } from '@crm/shared'

// Текст PDF с координатами надписей — для счёта из 1С в PDF (21.10.2026).
// pdf.js (~1 МБ) грузится отдельным чанком только при выборе PDF-файла, как SheetJS
// в loadXlsx; разбор надписей в строки — pdfTextToRows в @crm/shared.
export async function loadPdfText(data: ArrayBuffer): Promise<PdfTextItem[]> {
  let pdfjs: typeof import('pdfjs-dist')
  let workerUrl: string
  try {
    pdfjs = await import('pdfjs-dist')
    workerUrl = (await import('pdfjs-dist/build/pdf.worker.min.mjs?url')).default
  } catch (err) {
    console.error('[loadPdfText] не удалось загрузить чанк pdf.js', err)
    throw new Error('Не удалось загрузить модуль PDF — обновите страницу и попробуйте снова')
  }
  pdfjs.GlobalWorkerOptions.workerSrc = workerUrl
  const doc = await pdfjs.getDocument({ data: new Uint8Array(data) }).promise
  const items: PdfTextItem[] = []
  try {
    for (let page = 1; page <= doc.numPages; page++) {
      const content = await (await doc.getPage(page)).getTextContent()
      for (const it of content.items) {
        if (!('str' in it)) continue
        items.push({ page, x: it.transform[4], y: it.transform[5], width: it.width, str: it.str })
      }
    }
  } finally {
    void doc.destroy()
  }
  return items
}
